import {
  Avatar,
  Box,
  Divider,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
} from "@mui/material";
import { Home, Settings, Logout, Notifications } from "@mui/icons-material";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircle";
import MarkunreadMailboxIcon from "@mui/icons-material/MarkunreadMailbox";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { enqueueSnackbar } from "notistack";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import HttpsIcon from "@mui/icons-material/Https";
import FilePresentIcon from "@mui/icons-material/FilePresent";

import CustomConfirmation from "../popUp/CustomConfirmation";
import { s3baseUri } from "../../config/config";
import FeedbackIcon from "@mui/icons-material/Feedback";
import {
  candidate_api_detail_fetch,
  client_detail_api,
} from "../../DAL/TalentSourceAPI/TalentSourceApi";
import { useIds } from "../../hook/AdminContext";
import GeneralMuiModal from "./MenuModalMui";
import ChangePassword from "./ChangePassword";
import FeedBack from "./FeedBack";
import { user_logout } from "../../DAL/auth/auth";
import { switch_profile } from "../../DAL/manage-users/manage-users";
import { Check } from "lucide-react";
import { Icon } from "@iconify/react/dist/iconify.js";

export default function Accountmenu({ anchorEl, open, handleClose }) {
  const {
    profileNewImage,
    userInfo,
    setUserInfo,
    STOP_SOCKET_FORCEFULLY,
    setUserAPIData,
    setProfileSwitchLoader,
    fetctUserDetail,
    handleSwitchProfile,
  } = useIds();
  const navigate = useNavigate();
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);
  const [profileChangeConfirmation, setProfileChangeConfirmation] =
    useState(false);
  const [targetProfileId, setTargetProfileId] = useState(false);
  const [viewAllProfiles, setViewAllProfiles] = useState(false);
  const [profileImage, setProfileImage] = useState();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [openFeedback, setOpenFeedback] = useState(false);

  const handleProfile = () => {
    navigate("/profile");
    handleClose();
  };
  const handleManageUsers = () => {
    navigate("/manage-users");
    handleClose();
  };
  const redirectToInvitations = () => {
    navigate("/invitations");
    handleClose();
  };
  const handlePAymentRequests = () => {
    navigate("/payment-requests");
    handleClose();
  };

  const handleDialogueOpen = () => {
    handleClose();
    setLogoutDialogOpen(true);
  };

  const handleLogout = async () => {
    const resp = await user_logout();
    if (resp.code == 200) {
      setUserAPIData(null);
      setUserInfo(null);
      STOP_SOCKET_FORCEFULLY();
      localStorage.clear();
      navigate("/login");
      enqueueSnackbar("Logout Successful.", { variant: "success" });
    } else {
      enqueueSnackbar(resp.message, { variant: "error" });
    }
    setLogoutDialogOpen(false);
  };

  const navigateHome = () => {
    navigate("/home");
    handleClose();
  };

  const handleChangeProfile = async (id) => {
    handleClose();
    setTargetProfileId(id);
    setProfileChangeConfirmation(true);
  };

  useEffect(() => {
    if (open) {
      setViewAllProfiles(false);
    }
  }, [open]);

  return (
    <>
      <FeedBack
        openFeedback={openFeedback}
        setOpenFeedback={setOpenFeedback}
        user={userInfo}
      />

      <CustomConfirmation
        open={logoutDialogOpen}
        setOpen={setLogoutDialogOpen}
        title="Are you sure you want to sign out?"
        headerHeading={"Sign Out"}
        handleAgree={handleLogout}
      />
      <CustomConfirmation
        open={profileChangeConfirmation}
        setOpen={setProfileChangeConfirmation}
        title="Are you sure you want to switch profile?"
        headerHeading={"Switch Profile"}
        handleAgree={() => {
          setProfileChangeConfirmation(false);
          handleSwitchProfile(targetProfileId);
        }}
        additionalInfo={
          "When you switch your profile, all sessions on other devices will expire for security reasons. Your current device will stay logged in."
        }
        infoTitle={"Warning"}
      />
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            mt: 1.5,
            borderRadius: "10px",
            minWidth: "220px",
            "&::before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
      >
        {userInfo?.profiles?.length > 0 &&
        userInfo?.role !== "internal_user" ? (
          <div className="tw-card hover-disabled tw-p-2 tw-m-2 tw-max-h-[50vh] !tw-overflow-y-auto hide-scrollbar">
            <div className="d-flex align-items-center mb-2">
              {viewAllProfiles && (
                <IconButton
                  onClick={() => {
                    setViewAllProfiles(!viewAllProfiles);
                  }}
                  className="me-2"
                >
                  <ArrowBackIcon />
                </IconButton>
              )}
              <h6 className="mb-0">Switch Profile</h6>
            </div>
            <Tooltip title="Switch Profile" position={"bottom"}>
              <MenuItem
                className={`!tw-rounded-lg !tw-mb-3 tw-card  ${
                  userInfo?._id == userInfo?.profile_id ? "active" : ""
                }`}
                onClick={() => handleChangeProfile(userInfo?._id)}
                sx={{
                  pointerEvents:
                    userInfo?._id == userInfo?.profile_id ? "none" : "",
                  justifyContent: "space-between",
                  alignItems: "start",
                  // paddingInlineEnd: "0px",
                }}
              >
                <div className="d-flex w-100">
                  <Avatar
                    src={s3baseUri + userInfo?.profile_image?.thumbnail_1}
                    sx={{ mr: 1 }}
                  />
                  <Box className="w-100">
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: "bold" }}
                      className="d-flex justify-content-between w-100"
                    >
                      {userInfo?.role == "client"
                        ? userInfo?.company_name
                        : `${userInfo?.first_name} ${userInfo?.last_name}`}
                      <span className="outlined-chip  d-inline-block ms-2">
                        My Account
                      </span>
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{ fontSize: "12px", opacity: 0.8 }}
                    >
                      {userInfo?.email}
                    </Typography>
                  </Box>
                </div>

                {userInfo?._id == userInfo?.profile_id && (
                  <Icon
                    icon={"icon-park-solid:check-one"}
                    className="ms-3 tw-text-success"
                  />
                )}
              </MenuItem>
            </Tooltip>
            {/* <Divider /> */}

            {(viewAllProfiles
              ? userInfo?.profiles
              : userInfo?.profiles.slice(0, 2)
            ).map((obj, index) => (
              <>
                <Tooltip title="Switch Profile" position={"bottom"}>
                  <MenuItem
                    className={`!tw-rounded-lg !tw-mb-3 tw-card  ${
                      obj._id == userInfo?.profile_id ? "active" : ""
                    }`}
                    onClick={() => handleChangeProfile(obj._id)}
                    sx={{
                      pointerEvents:
                        obj._id == userInfo?.profile_id ? "none" : "",
                      justifyContent: "space-between",
                      alignItems: "start",
                      // paddingInlineEnd: "0px",
                    }}
                  >
                    <div className="d-flex">
                      <Avatar
                        src={s3baseUri + obj?.profile_image?.thumbnail_1}
                        sx={{ mr: 1 }}
                      />
                      <Box>
                        <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                          {obj?.company_name ||
                            `${obj?.first_name} ${obj?.last_name}`}
                        </Typography>

                        <Typography
                          variant="body2"
                          sx={{ fontSize: "12px", opacity: 0.8 }}
                        >
                          {obj?.email}
                        </Typography>
                      </Box>
                    </div>
                    {obj._id == userInfo?.profile_id && (
                      <Icon
                        icon={"icon-park-solid:check-one"}
                        className="ms-3 tw-text-success"
                      />
                    )}
                  </MenuItem>
                </Tooltip>

                {/* {index !== userInfo?.profiles.length - 1 && <Divider />} */}
              </>
            ))}

            {userInfo?.profiles.length > 2 && !viewAllProfiles && (
              <div className="text-center d-flex justify-content-center">
                <button
                  className="btn-outlined-sm mt-2"
                  onClick={() => {
                    setViewAllProfiles(!viewAllProfiles);
                  }}
                >
                  View All Profiles
                </button>
              </div>
            )}
          </div>
        ) : (
          <div className="side-profile-menu tw-px-4 tw-py-2 d-flex align-items-center">
            <>
              <Avatar
                src={
                  s3baseUri +
                  userInfo?.company_profile?.profile_image?.thumbnail_1
                }
                sx={{ mr: 1 }}
              />
              <Box>
                <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                  {userInfo?.role == "client" || userInfo?.isCompanyProfile
                    ? userInfo?.company_profile?.company_name
                    : `${userInfo?.first_name} ${userInfo?.last_name}`}
                </Typography>

                <Typography
                  variant="body2"
                  sx={{ fontSize: "12px", opacity: 0.8 }}
                >
                  {userInfo?.company_profile?.email || userInfo?.email}
                </Typography>
              </Box>
            </>
          </div>
        )}

        {!viewAllProfiles && (
          <>
            <Divider />
            <MenuItem onClick={navigateHome}>
              <ListItemIcon>
                <Home
                  fontSize="small"
                  style={{ color: "var(--portal-secondary-color)" }}
                />
              </ListItemIcon>
              Home
            </MenuItem>
            {(!userInfo?.isCompanyProfile ||
              (userInfo?.isCompanyProfile &&
                userInfo?.company_access?.manage_profile?.company_profile)) && (
              <MenuItem onClick={handleProfile}>
                <ListItemIcon>
                  <Settings
                    fontSize="small"
                    style={{ color: "var(--portal-secondary-color)" }}
                  />
                </ListItemIcon>
                Profile
                {((userInfo?.direct_contact_check ||
                  userInfo?.has_pending_affiliation_request) &&
                  !userInfo?.isCompanyProfile) ||
                (userInfo?.isCompanyProfile &&
                  userInfo?.company_access?.manage_profile?.company_profile &&
                  (userInfo?.direct_contact_check ||
                    userInfo?.has_pending_affiliation_request)) ? (
                  <span
                    style={{
                      display: "inline-block",
                      width: 10,
                      height: 10,
                      backgroundColor: "red",
                      borderRadius: "50%",
                      marginLeft: "1rem",
                    }}
                  />
                ) : (
                  ""
                )}
              </MenuItem>
            )}
            {((userInfo?.role == "client" && !userInfo?.isCompanyProfile) ||
              (userInfo?.isCompanyProfile &&
                userInfo?.company_access?.manage_profile?.manage_user)) && (
              <MenuItem onClick={handleManageUsers}>
                <ListItemIcon>
                  <SupervisedUserCircleIcon
                    fontSize="small"
                    style={{ color: "var(--portal-secondary-color)" }}
                  />
                </ListItemIcon>
                Manage Users
              </MenuItem>
            )}
            {!userInfo?.isCompanyProfile && (
              <MenuItem onClick={redirectToInvitations}>
                <ListItemIcon>
                  <MarkunreadMailboxIcon
                    fontSize="small"
                    style={{ color: "var(--portal-secondary-color)" }}
                  />
                </ListItemIcon>
                Invitations
                {userInfo?.user_invitaion_status && (
                  <span
                    style={{
                      display: "inline-block",
                      width: 10,
                      height: 10,
                      backgroundColor: "red",
                      borderRadius: "50%",
                      marginLeft: "1rem",
                    }}
                  />
                )}
              </MenuItem>
            )}
            {userInfo?.role === "client" && !userInfo?.isCompanyProfile && (
              <MenuItem onClick={handlePAymentRequests}>
                <ListItemIcon>
                  <AccountBalanceIcon
                    fontSize="small"
                    style={{ color: "var(--portal-secondary-color)" }}
                  />
                </ListItemIcon>
                Payment Requests
                {userInfo?.has_pending_requests && (
                  <span
                    style={{
                      display: "inline-block",
                      width: 10,
                      height: 10,
                      backgroundColor: "red",
                      borderRadius: "50%",
                      marginLeft: "1rem",
                    }}
                  />
                )}
              </MenuItem>
            )}
            {!userInfo?.isCompanyProfile && userInfo?.role == "candidate" && (
              <MenuItem
                onClick={() => {
                  handleClose();
                  navigate("/cv-management");
                }}
              >
                <ListItemIcon>
                  <FilePresentIcon
                    fontSize="small"
                    style={{ color: "var(--portal-secondary-color)" }}
                  />
                </ListItemIcon>
                CV Management
              </MenuItem>
            )}
            {(!userInfo?.isCompanyProfile ||
              userInfo?.role == "internal_user") && (
              <MenuItem
                onClick={() => {
                  handleClose();
                  navigate("/profile/change-password");
                }}
              >
                <ListItemIcon>
                  <HttpsIcon
                    fontSize="small"
                    style={{ color: "var(--portal-secondary-color)" }}
                  />
                </ListItemIcon>
                Change Password
              </MenuItem>
            )}
            {((!userInfo?.isCompanyProfile &&
              userInfo?.role !== "internal_user") ||
              userInfo?.company_access?.manage_profile?.company_profile) && (
              <MenuItem
                onClick={() => {
                  handleClose();
                  setOpenFeedback(true);
                }}
              >
                <ListItemIcon>
                  <FeedbackIcon
                    fontSize="small"
                    style={{ color: "var(--portal-secondary-color)" }}
                  />
                </ListItemIcon>
                Feedback
              </MenuItem>
            )}
            <Divider />
            <MenuItem sx={{ color: "red" }} onClick={handleDialogueOpen}>
              <ListItemIcon>
                <Logout fontSize="small" sx={{ color: "red" }} />
              </ListItemIcon>
              Sign Out
            </MenuItem>
          </>
        )}
      </Menu>
    </>
  );
}
